import type { Immutable } from 'immer';
import type { CurrentEvent } from '../../store/events/events_reducers';
import { useStore } from '../../store/reducers';

export function useCurrentEvent(): Immutable<CurrentEvent> | null {
  return useStore((s) => s.events.getter.currentEvent());
}
